import { Component, HostListener, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, switchMap, take, timer } from 'rxjs';
import { GenesysCloudService } from 'src/app/services/genesys-cloud.service';
import { LogService } from 'src/app/services/log.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import * as Constants from '../../models/Constants';
import * as platformClient from 'purecloud-platform-client-v2';
import * as _ from 'lodash';
import { ApiService } from '../../services/api.service';
import { AwsSqsService } from '../../services/aws-sqs.service';
import { SpeedTestService } from 'ng-speed-test';
import { DashboardBusinessLogicService } from 'src/app/services/dashboard-business-logic.service';
import { MatDialog } from '@angular/material/dialog';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { LogoutBusinessLogicService } from 'src/app/services/logout-business-logic.service';
import { BatchAlertService } from 'src/app/services/batch-alert.service';
import { OtcService } from 'src/app/services/otc.service';


@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent implements OnInit, OnDestroy {
  loading$ = this.rootScope.loading$;
  isAuthorized = false;
  title = 'Care Portal';
  public alertConfig = {
    type: 'error',
  };
  displayAlert: boolean = false;
  subscription: Subscription;
  networkSpeedSubscription!: Subscription;
  showUserProfileCard: boolean = false;
  inboundMsg: string = Constants.INBOUND_CALL_ACCESS_ERRORMSG;
  utilityErrMsg=Constants.UTILITY_ERROR_MSG;
  getValidFieldValuesApiFailureMsg = Constants.GET_VALID_FIELD_VALUES_API_FAILURE_MSG;
  breadcrumbItems: Array<any> = [
    {
      name: 'Customer Account',
      url: '/customer-account',
      selected: false,
      id: 1,
    },
    {
      name: 'Interaction History',
      url: '/interaction-history',
      selected: true,
      id: 2,
    },
    { name: 'Invoicing', url: '/invoicing', selected: true, id: 3 },
    { name: 'Current', url: '/current', selected: false, id: 4 },
  ];
  loadUI: boolean = true;
  currentActiveTabId: any;
  isSSODuplicate: boolean = false;
  loaderType = Constants.LOADER_TYPE.FULL_SCREEN;
  utilityError=Constants.UTILITY_INDICATOR_COLOR.RED;

  constructor(
    public genesysCloudService: GenesysCloudService,
    private route: ActivatedRoute,
    public apiService: ApiService,
    public rootScope: RootScopeService,
    public router: Router,
    private logger: LogService,
    private awssqsservice: AwsSqsService,
    public speedTestService: SpeedTestService,
    public dashboardService: DashboardBusinessLogicService,
    public dialog: MatDialog, public idle: Idle, public logOutService: LogoutBusinessLogicService,
    public batchAlertService: BatchAlertService,
    public otcService: OtcService
  ) {
    /* istanbul ignore next */
    this.subscription = this.genesysCloudService
      .onMessage()
      .subscribe((message) => {
        if (message) {
          this.connectToGenesys();
        }
      });
    this.updateIdleStatus();

    /*** If user prefers to go with new session on, previous opened tab should redirect to
     * chrome default page as previous sessionId is expired 
  
    window.addEventListener('storage', (event) => {
      console.log('event', event);
      if (event.key == 'userSession' && event.oldValue == null) {
        window.open('http://www.google.com', '_self');
      }
    });*/
  }



  /**
   * Lifecycle hook that is called after data-bound properties of a component are initialized.
   * 
   * - Handles session reload logic by checking if a reload was attempted, extracting the access token from the URL fragment,
   *   updating local storage with the new token, and closing the window if necessary.
   * - Initializes the session ID and logs the platform client for debugging purposes.
   * - Subscribes to network speed checks at intervals defined by `rootScope.timeThreshold`, triggering network status and speed checks.
   * - Initializes the external tab list for the CCR Dashboard and sets the user as logged in.
   */
  
  ngOnInit() {
    /* istanbul ignore next */
   
    this.setSessionId();

    /* istanbul ignore next */
    this.networkSpeedSubscription = this.rootScope.timeThreshold
      .pipe(switchMap((period: number) => timer(0, period)))
      .subscribe((res) => {
        this.getNetworkOnline();
        this.getSpeed();
      });
      this.rootScope.externalTabList.set( Constants.CCR_Dashboard,[])
      this.rootScope.userLoggedIn = true;
  }



  setSessionId() {

    if (!this.rootScope.sessionId) {
      this.rootScope.sessionId = localStorage.getItem('userSession');
    }

    if (!this.rootScope.emailId) {
      this.rootScope.emailId = localStorage.getItem('emailId');
    }

    if (!this.rootScope.firstName) {
      this.rootScope.firstName = sessionStorage.getItem('firstIdentity') || '';
    }

    if (!this.rootScope.lastName) {
      this.rootScope.lastName = sessionStorage.getItem('lastIdentity') || '';
    }

    if (!this.rootScope.lanId) {
      this.rootScope.lanId = localStorage.getItem('lanId');
    }

    if (!this.rootScope.browserSessionStartTimestamp) {
      this.rootScope.browserSessionStartTimestamp = sessionStorage.getItem('browserSessionStartTimestamp') || new Date().toISOString();
    }

    this.rootScope.createNameForUserProfile(
      this.rootScope.firstName,
      this.rootScope.lastName,
      this.rootScope.lanId, this.rootScope.browserSessionStartTimestamp,this.rootScope.emailId
    );
    this.rootScope.setUserAndEmailInStorage();
    this.checkMultiSessionScenario();
  }



  /**
   * Below method fetches the application
   * related configuration data and
   * store globaly in appConfigObj variable
   * @author :Pooja Gupta
   */
  getApplicationConfiguration(onSuccess?: () => void) {
    let that = this;
    this.apiService.getApplicationConfiguration().subscribe({
      next: (data) => {
        /* istanbul ignore next */
        if (data) {
          console.log('Application configuration data = ', data);
          that.rootScope.appConfigObj = data['data'];
          that.awssqsservice.getAWSConfigObj();
          that.rootScope.createCCTConfigObj();
          that.awssqsservice.loadAWSconfigForAngularLogs();
          that.rootScope.getNetworkConfigValues();
          that.appIdleTimeoutSetUp();
          this.dashboardService.startTimerCheckAlisRefresh();   //timer for ALIS intraction refresh tracker CCR3-CCR3-6969
          /* istanbul ignore next */
          if (that.rootScope.isAuthenticate && this.rootScope.loadUI) {
            that.apiService.validateTimeStampToken();
            that.rootScope.setTimeOutDetails({ 'watch': true, 'stop': false });
          }
          const isHostName = this.rootScope.getObjFromConfigObj(Constants.HOST_NAME)?.fieldValue;
          this.rootScope.hostName = isHostName ? isHostName : Constants.LOCAL_HOST_NAME;
          onSuccess?.();
        } else {
          this.rootScope.hostName = Constants.LOCAL_HOST_NAME;
          onSuccess?.();
        }
      },
      error: (error) => {
        this.logger.log(error);
        that.appIdleTimeoutSetUp();
        this.rootScope.hostName = Constants.LOCAL_HOST_NAME;
        onSuccess?.();
      },
    });
  }

  /**
   * Below method main focus on handling of
   * various ways of launchig app and in valid and invalid(duplicate Session) Scenario
   * @author :Pooja Gupta
   */

  checkMultiSessionScenario() {
   

    /*** Case 1:Launch of application via SSO  ****/
   
    if (this.rootScope.launchAppBySSO) {
      this.loadApp();
      this.rootScope.launchAppBySSO = false;
    } else if (this.rootScope.isSSODuplicate) {
      /***Launch app via SSO but its duplicate *****/
      this.validateAppLoad();
    } else if (this.rootScope.launchAppFromManualLogin) {
      /*** Case 2:Launch of application via Manual Login Page and its found to be duplicate from backend ****/
      if (this.rootScope.isDuplicateSession == 'true') {
        this.validateAppLoad();
      } else {
        this.loadApp();
      }
    } else {
      /*** Case 3 & 4 :Launch of application via click on open duplicate tab OR  bookmark app url OR directly loading app dashboard URL */
       /* istanbul ignore next */
      this.apiService.getInfoAbtDuplicateSession().subscribe({
        next: (data2) => {
          //  console.log('datat', data2);
          let data = data2['data'];
          if (data['isDuplicate'] == 'true') {
            /********Case 5 : User refreshes the application on active as well as on not active opened tab  ****/
            if (sessionStorage.getItem('isActiveTabRefreshed') == 'true' && sessionStorage.getItem('ALISRegistration') == 'true') {
              if (this.rootScope.sessionId == data['jSessionId']) {
                this.rootScope._isAuthenticated.next(true);
                this.loadApp();
                sessionStorage.setItem('isActiveTabRefreshed', 'false');
                sessionStorage.setItem('ALISRegistration', 'false');//only for ALISRegistration navigation
              } else {
                /** Here basically if user has changed the session in another browser  and user comes again to already opened previos session in another browser **/
                this.validateAppLoad();
              }
            } else {
              this.validateAppLoad();
            }
          } else {
            this.loadApp();
          }
        },
        error: (error) => {

          // console.log(
          //   'Error in getting response of DUplicate session from backend',
          //   error
          // );
          this.rootScope.enableAlerts(
            Constants.ERROR,
            Constants.API_FAILURE_MSG
          );
          this.router.navigate(['/login']);
        },
      });
    }
  }

  getAppData() {    
    this.getApplicationConfiguration(() => {
      this.launchUtility();
      this.dashboardService.runTimeUtilityLogin(this.rootScope.lanId);
    });
    this.genesysCloudService.customerService.getClientDetails();
    // this.apiService.customerAccountApis();
    this.getDataForCustomerAccountApi();
    // this.apiService.getDuelDeskTopIndicator();
    this.apiService.getBuildDetails();
  }
 

  loadApp() {
    this.getAppData();
    this.rootScope.loadUI = true;
    this.genesysStatus();
    this.onLoadTbaGuiReg();
    /* istanbul ignore next */
    this.apiService.getRestoreAccountDetails();
  }

  /**
   * Validates the application load state and handles multi-session scenarios.
   *
   * - If a reload has been attempted (tracked via sessionStorage), it calls the API service to handle multi-session logic,
   *   removes the reload flag, and skips showing the popup.
   * - If no reload has been attempted, it displays a popup to the user.
   * - Sets the UI loading indicator to false.
   * - Calls `getAppData()` to fetch application data.
   *
   * @remarks
   * The method uses sessionStorage to track reload attempts and ensures that multi-session handling
   * is only triggered once per session. The UI loading state is updated regardless of the reload state.
   */
  validateAppLoad() {
   
    this.showPopup();
    this.rootScope.loadUI = false;
    /* istanbul ignore next */
    this.getAppData();
  }

  /**Below Method Check if the user is Connected to Genesys Clour or in Live Call */
  genesysStatus() {
    if (sessionStorage.getItem('connectToGenesys') == 'true') {
      var ALIS_region: any = sessionStorage.getItem('ALIS_region');
      this.genesysCloudService.environment = ALIS_region;
      this.connectToGenesys();
      sessionStorage.removeItem('isLiveCall');
    }
    // if (sessionStorage.getItem('isLiveCall') == 'true')
    //   this.genesysCloudService.genesysNotifyCallOrChat(true);
  }

  /**Below method is used to connect the Care Portal Application with the Genesys Cloud
   * which take the user on Genesys Login Page by redirecting it. */
  /* istanbul ignore next */
  connectToGenesys() {
   
    this.route.queryParams.pipe(take(1))?.subscribe((params) => {
    
      this.rootScope.alisRegistrationLoaderTimeoutId = setTimeout(() => {
        this.rootScope.showAlisRegistrationLoaderMsg = true;
      }, 1 * this.rootScope.showLoaderMsgThreshold * 1000);

      this.rootScope.alisRegistrationLoader = true;
      this.genesysCloudService.initialize().subscribe({
        next: (res: any) => {
          this.genesysCloudService.closeRegistrationAuthWindow();
          clearTimeout(this.rootScope.alisRegistrationLoaderTimeoutId);
          this.rootScope.alisRegistrationLoader = false;
          this.rootScope.showAlisRegistrationLoaderMsg = false;
          this.rootScope.ALISRegistrationCardMsgAfterSessionPopUp = false;
          this.getUserId();
          this.rootScope.setIsGensysLoggedIn(true);
          if(this.batchAlertService.checkBatchAlertModeActive()){
            this.batchAlertService.turnBatchAlertModeOnWithoutRoute();
          }
          
        
       /**
        * This method is called to address CCR1-7210. In CCR5-951, we commented out the getUserDetails() call in the ALIS Registration Component to avoid duplicate API requests for user details.
        *  Although getUserDetails() is already called in the login module flow, we invoke it here specifically when redirecting back from registration.
        */
          this.apiService.getUserDetails();
          this.logger.info('Succesfully logged in gensys.');
          this.dashboardService.savePreferenceValue().subscribe({
            next: (data: any) => {
              if (data?.httpStatusCode == 200) {
                //  console.log('save preference value sucussfully in database', data);
              }
            },
            error: (error) => {
      /**
        * This method is called to address CCR1-7210. In CCR5-951, we commented out the getUserDetails() call in the ALIS Registration Component to avoid duplicate API requests for user details.
        *  Although getUserDetails() is already called in the login module flow, we invoke it here specifically when redirecting back from registration.
        */
              this.apiService.getUserDetails();
              this.rootScope.enableAlerts(Constants.ERROR, Constants.API_FAILURE_MSG);

            },
          });

          this.getPresenceStatus();
          this.rootScope.ALISRegistrationSuccessChangeOrg = true;
          this.rootScope.ALISRegistrationCardSuccess = true;
          this.rootScope.ALISRegistrationCardError = false;
          //Below code is used to display one alert at a time.
          this.rootScope.ALISChangeOrgInfoMsg = false;
           /* istanbul ignore next */
           setTimeout(() => {
            if (this.rootScope.alisOrganizations?.length > 0 && this.rootScope.isGenesysLoggedIn) {
              this.genesysCloudService.getOrganizationsMe();

             }
           }, 150);
        },
        error: (error) => {
          this.genesysCloudService.closeRegistrationAuthWindow();
          clearTimeout(this.rootScope.alisRegistrationLoaderTimeoutId);
          this.rootScope.alisRegistrationLoader = false;
          this.rootScope.showAlisRegistrationLoaderMsg = false;
          this.rootScope.ALISRegistrationCardError = true;
        },
      });
    });

    // if (!localStorage.getItem('userId')) {
    //   this.getUserId();
    // }
  }

  userId: any = '';
  /*istanbul ignore next */
  getUserId() {
    this.genesysCloudService.getUserId().subscribe({
      next: (userDetails) => {
        if(userDetails?.id) {
          this.userId = userDetails.id;
          localStorage.setItem('userId', this.userId);
          this.genesysCloudService.genesysCloudNotificationSetup();
        }
      },
      error: (error) => {
        this.logger.error(error);
        this.rootScope.enableAlerts(Constants.ERROR, Constants.API_FAILURE_MSG);
      },
  }   );
  }

 
  /**Below method get the User details of ALIS from which we get the presence status of ALIS */
  getPresenceStatus() {
    this.genesysCloudService.getUserMe().subscribe({
      next: (res) => {
        let presence: any = res?.presence?.presenceDefinition?.systemPresence;
        this.genesysCloudService._presenceStatus.next(presence);
        if(localStorage.getItem('userId') !== res?.id) {
          localStorage.setItem('userId', res.id||"");
        }
      },
      error: (error) => { },
    });
  }

  /**istanbul ignore next */
  // onBreadcrumbSelect(evnt) {
  //   // console.log('Method onBreadcrumbSelect called ', evnt);
  //   if (evnt.detail) {
  //     this.breadcrumbItems = _.filter(
  //       this.breadcrumbItems,
  //       function (currentObject) {
  //         return currentObject.id !== evnt.detail.id;
  //       }
  //     );
  //   }
  // }

  /***** Below method is called whenever user closes the tab /browser window or refreh the browsser
   
    * Used for handling a sceanrio where user refreshes active tab at that time prompt should not appear
    * as its not case of multiple session .
    *  ******/

  @HostListener('window:beforeunload', ['$event'])
  
  beforeunloadHandler(event) {
    if (this.rootScope.loadUI) {
      sessionStorage.setItem('isActiveTabRefreshed', 'true');
    } else {
      sessionStorage.setItem('isActiveTabRefreshed', 'false');
    }

  }

  
  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    // console.log(event);
    let x = event?.keyCode;
    if (x === 27) {
      // console.log('Escape!');
    }
  }
  // Common Method here
  showPopup() {
    this.rootScope.openDialog({
      title: '',
      subheading: '',
      message: Constants.MULTI_SESSION_DIALOG_MSG,
      firstbutton:Constants.buttonEnum.restoreLastSession,
      secondbutton:  Constants.buttonEnum.opneNewSession,
      crossIcon: false,
      comingFrom: 'main',
      additionalClass: 'multi-session-modal',
    });

    this.apiService.appSessionTimer();
  }



  /**Below method check if the network is available and return the boolean value
   *  that is internet connection is active or inactive. */
  getNetworkOnline() {
    this.speedTestService.isOnline().subscribe((isOnline) => {
      if (isOnline === true) {
        this.rootScope.isNetworkOnline = true;
      } else {
        this.rootScope.isNetworkOnline = false;
      }
    });
  }

  /**Below method get the current internet speed in Mbps (megabits per second).*/
   
  getSpeed() {

    const customSettings = {
      iterations: 5,           // Run 5 tests for better accuracy
      retryDelay: 1000,       // Wait 1 second between retries
      file: {
        path: '/assets/images/5mb.jpg',
        size: 5242880,        // 5MB in bytes
        shouldBustCache: true // Prevent browser caching
      }
};
    this.speedTestService
      .getMbps(customSettings)
      .subscribe((speed) => {
        this.rootScope.speed.next(Math.round(speed));
        console.log(
          'Your speed is ' +
          speed +
          '>>>' +
          ', network online :' +
          this.rootScope.isNetworkOnline
        );
        return speed;
      });
  }


  /**
   * Below method  checks if the 'TBAGUIRegistrationnAuthorized' item is present in the localStorage and if the 'isConnected' item is true.
   *If both conditions are met, it sets the 'TBAGUIRegistrationnAuthorized' flag to true and starts the TBA connectivity interval through the dashboard service.
  */
  onLoadTbaGuiReg() {
    let isPresent = localStorage.getItem('TBAGUIRegistrationnAuthorized');
    let isConnected = localStorage.getItem('isConnected');
    if (isPresent && isConnected) {
      this.rootScope.TBAGUIRegistrationnAuthorized = true;
      this.dashboardService.startTbaConnectivityInterval();
    }
  }

  /**
  * Below method handles triggering idel timmer to handle inactivity in application level
  * failure or success.
  * If user reach 29.30 secconds needs to prompt alert msg and will be
  * when user reach 30 mints redirected to logoff page and CLOSE the model popup
  */
  appIdleTimeoutSetUp() {
   this.apiService.globalIconIdUpdate(Math.floor(Math.random() * Constants.IndexId));
  
    this.idle.stop();
    // sets an idle timeout of 29.30MIN, for purposes.
    this.idle.setIdle(this.rootScope.CCTConfigs.APP_IDLE_TIME);
    // sets a timeout period of 30 seconds. after 29.30 MIN of inactivity, the user will be considered timed out.
    this.idle.setTimeout(this.rootScope.CCTConfigs.APP_TIMEOUT);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onTimeoutWarning.subscribe((secondsLeft: number) => {
      /* istanbul ignore next */
      if (secondsLeft == this.rootScope.CCTConfigs.APP_TIMEOUT && !this.dialog.getDialogById('timeOutPopUp')) {
        this.rootScope.clearInterval = false;
        this.apiService.globalIconUpdate(true);
        this.appTimeOutAlertTimer();
      }
    });

    // this.idle.onIdleStart.subscribe((secondsLeft: any) => {

    // });
 /* istanbul ignore next */
    this.idle.onTimeout.subscribe(() => {
      setTimeout(() => {
        if (this.rootScope.isAuthenticate && !this.rootScope.clearInterval) {
          clearInterval(this.rootScope.timemoutPopUpInteraval);
          this.apiService.globalIconUpdate(true);
          this.logOutService.appLogOut(this);
        }
      }, 500);

    });
  }

  /**
    * Below method handles dynmic timer seconds running a counter down secs and
    * stop timer intervel once it reaches zero sec
    * 
    */
  appTimeOutAlertTimer() {

    if (location?.pathname?.includes(Constants.pathname)) this.idle.stop();
    else {
      let timeLeft = this.rootScope.CCTConfigs.APP_TIMEOUT;
      this.rootScope.timespan = this.rootScope.CCTConfigs.APP_TIMEOUT + ' seconds';
      this.rootScope.timemoutPopUpInteraval = setInterval(() => {
        this.rootScope.timespan = timeLeft?.toString() + ' seconds';
        if (this.rootScope.clearInterval) {
          clearInterval(this.rootScope.timemoutPopUpInteraval);
          this.rootScope.clearInterval = false;
          this.apiService.globalIconUpdate();
        }
        else if (timeLeft > 0) {
          timeLeft--;
        } else {
          clearInterval(this.rootScope.timemoutPopUpInteraval);
          /* istanbul ignore next */
          this.rootScope.clearInterval = true;
          /* istanbul ignore next */
          this.logOutService.appLogOut(this, true);
        }
      }, 1000);
      this.rootScope.openTimeoutDialog();
    }
  }

  /**
   * update idle timer status stop and start
   */
  updateIdleStatus() {
    this.rootScope.getTimeOutDetails().subscribe((data: any) => {
      if (data?.stop)
        this.idle.stop();
      else if (data?.watch) {
        this.idle.setIdle(this.rootScope.CCTConfigs.APP_IDLE_TIME);
        this.idle.setTimeout(this.rootScope.CCTConfigs.APP_TIMEOUT);
        this.idle.watch();
      }
    });
  }



 

 
  launchUtility() {
    this.rootScope.tbawindow.set(this.rootScope.sessionId, window.open(Constants.TBA_LOGIN_URL, '_self'));
  }

  // To check if the tab is visible and validate the timestamp everytime the tab is switched
  /* istanbul ignore next */
 @HostListener('document:visibilitychange', ['$event']) checkVisibility(event: Event): void {
   /* istanbul ignore next */
  if (document.visibilityState === 'visible' && this.rootScope.userLoggedIn == true) {
    console.log("tab changed");
    this.rootScope.browserSubscription?.unsubscribe();
    this.apiService.validateTimeStampToken();
    console.log("logout");
  }
   /* istanbul ignore next */
  if (document.visibilityState === 'hidden' && this.rootScope.timerStarted == true) {
    console.log("unsubcribe");
    console.log(this.rootScope.userLoggedIn);
  }
}


getDataForCustomerAccountApi(){
  this.rootScope.getValidFieldValuesApiFailure = false;

  this.apiService.getDataByValidValuesApi().subscribe({
    next: (res: any) => {
      /* istanbul ignore next */
      let respDataObj = res?.data;

       /* istanbul ignore next */
      if(respDataObj && respDataObj[Constants.CUSTOMER_TYPE] )
        this.rootScope.customerTypeData = respDataObj[Constants.CUSTOMER_TYPE];
      else{
        this.rootScope.customerTypeAPIFailure = true;  
      }

      /* istanbul ignore next */
      this.rootScope.thirdPartyList = respDataObj?.[Constants.THIRD_PARTY_LIST];
      /* istanbul ignore next */
      this.rootScope.primaryLanguage = respDataObj?.[Constants.PRIMARY_LANGUAGE];
      /* istanbul ignore next */
      this.rootScope.preferredLocale = respDataObj?.[Constants.PREFERRED_LOCALE];
      this.rootScope.alisOrganizations= respDataObj?.[Constants.ALIS_ORG] || [];
      /* istanbul ignore next */
      // if (this.rootScope.alisOrganizations?.length > 0 && this.rootScope.isGenesysLoggedIn) {
      //   this.genesysCloudService.getOrganizationsMe()
      // }
      
      let IHChannelList = respDataObj?.[Constants.CHANNEL_LIST];
      /* istanbul ignore next */
      if (IHChannelList) {
        IHChannelList.sort((a, b) => parseFloat(a?.sequence) - parseFloat(b?.sequence));
        this.rootScope.IHChannelList = IHChannelList;
      }
      
      let unknownCallerTypeList = respDataObj?.[Constants.UNKNOWN_CALLER_TYPE_LIST];

      if (unknownCallerTypeList) {
        unknownCallerTypeList.sort((a, b) => a?.fieldValueDescription.localeCompare(b?.fieldValueDescription));
        this.rootScope.unknownCallerTypeList = unknownCallerTypeList;
      } else {
        this.rootScope.unknownCallerTypeAPIFailure = true;
      }

      let interactionHistoryConfig = respDataObj?.[Constants.INTERACTION_HISTORY_CONF];
      if (interactionHistoryConfig) {
        let MAX_IH_RECORDS_LEGACYDATA_Obj = this.rootScope.getObjFromConfigObjValidValues(Constants.INTERACTION_HISTORY_CONFIGURATIONS.MAX_IH_RECORDS_LEGACYDATA, interactionHistoryConfig);
        let MAX_DAYS_FOR_LEGACYDATA_Obj = this.rootScope.getObjFromConfigObjValidValues(Constants.INTERACTION_HISTORY_CONFIGURATIONS.MAX_DAYS_FOR_LEGACYDATA, interactionHistoryConfig);

        this.rootScope.interactionHistoryConfig.MAX_IH_RECORDS_LEGACYDATA = MAX_IH_RECORDS_LEGACYDATA_Obj?.fieldValueDescription ? MAX_IH_RECORDS_LEGACYDATA_Obj?.fieldValueDescription : Constants.INTERACTION_HISTORY_CONFIGURATIONS.MAX_IH_RECORDS_LEGACYDATA_VALUE;
        this.rootScope.interactionHistoryConfig.MAX_DAYS_FOR_LEGACYDATA = MAX_DAYS_FOR_LEGACYDATA_Obj?.fieldValueDescription ? MAX_DAYS_FOR_LEGACYDATA_Obj?.fieldValueDescription : Constants.INTERACTION_HISTORY_CONFIGURATIONS.MAX_DAYS_FOR_LEGACYDATA_VALUE;
      }

      this.rootScope.cimData_config = respDataObj?.[Constants.CIM_DATA_ATTRIBUTE_MAPPING];
      // Check if the simulation types array exists and has elements
      if (respDataObj?.[Constants.SIMULATION.SIMULATION_TYPE]?.length) {
        // If simulation types are present, assign them to rootScope.simulationTypes
        // This allows the UI or business logic to use the available simulation types
        this.rootScope.simulationTypes = respDataObj?.[Constants.SIMULATION.SIMULATION_TYPE];
      }
      /** Below code use for OTC length in Authentication Module */
      const otcData = respDataObj?.[Constants.OTC_LENGTH_CONFIG];
      const data = otcData?.[0];
      if (data) {
        this.otcService.otcLenght = data?.fieldValueDescription;
        this.otcService.updateOtcLength(this.otcService?.otcLenght);
      }

      /** Below code is used to get the authorized role type data */
      const authorizedRoleTypeData = respDataObj?.[Constants.AUTHORIZED_ROLETYPE];
      if (authorizedRoleTypeData) {
        this.rootScope.authorized_roletype = authorizedRoleTypeData?.map((e) => e?.fieldValue);
      }  

       /** Below code is used to get the ALIS regions data */
       const alisRegionData = respDataObj?.[Constants.ALIS_REGION];
       if (alisRegionData) {
         this.rootScope.alisRegions = alisRegionData.map((regions) => {
           return {
             region: regions.fieldValue,
             displayName: regions.fieldValueDescription,
         }
       });
       
       this.rootScope.getPreferenceRegion();
       }

      /** Below code is used to get the PEAchannels data */
      const peaChannelsData = respDataObj?.[Constants.PIN_APP];
      if (peaChannelsData) {
        this.rootScope.PEAchannels = peaChannelsData?.map(x=>x?.fieldValue);
      }

      /* For VAL channel */
      const VALChannel = respDataObj?.[Constants.VAL_APP];
      if (VALChannel) {
        this.rootScope.VALChannel = VALChannel?.map(x=>x?.fieldValue);
      }

      /**For list of platformType whose platformInternalId data to be displayed in UI CCR1-101210  */
       const platformTypeList = respDataObj?.[Constants.ID_MAPPING_PLATFORM_TYPE];
      if (platformTypeList) {
        this.rootScope.platformTypeList = platformTypeList?.map(x=>x?.fieldValue);
      }

       /**For list of platformType whose platformInternalId data to be displayed in UI CCR1-101210  */
       const roleTypeListForPlatFormInternalIdTable = respDataObj?.[Constants.ROLE_TYPE_DETAILS];
      if (roleTypeListForPlatFormInternalIdTable) {
        // Create a map: key = fieldValue(ee,rkp), value = fieldValueDescription(Employee , RecordKeeper)
        this.rootScope.roleTypeListForPlatFormInternalIdTable = _.mapValues(_.keyBy(roleTypeListForPlatFormInternalIdTable, 'fieldValue'), 'fieldValueDescription');
      }


      /** Below code is used to get the recordCountBatchAlert & batchAlertExpiryDays data */
      const batchAlertConfig = respDataObj?.[Constants.BATCH_ALERT];
      if (batchAlertConfig) {
        const recordCountObj = this.rootScope.getObjFromConfigObjValidValues(Constants.RECORD_COUNT, batchAlertConfig);
        this.batchAlertService.recordCountBatchAlert = recordCountObj?.fieldValueDescription;

        const batchAlertExpiryObj = this.rootScope.getObjFromConfigObjValidValues(Constants.BATCH_ALERT_EXPIRY, batchAlertConfig);
        this.batchAlertService.batchAlertExpiryDays = batchAlertExpiryObj?.fieldValueDescription;
      }

      /** Below code is used to get the pinResetErrorList data */
      const pinResetErrorList = respDataObj?.[Constants.PIN_RESET_MSGS];
      if (pinResetErrorList) {
        this.rootScope.pinResetErrorList = pinResetErrorList;
      }

      
      /** Below code is used to get the screenPopDesktopIndicatorData data */
      const screenPopDesktopIndicatorData = respDataObj?.[Constants.SCREEN_POP_DESKTOP_INDICATOR];
      if (screenPopDesktopIndicatorData) {
        this.rootScope.duelDesk_indicator = screenPopDesktopIndicatorData?.map(item => item?.fieldValueDescription);
      }

      /** Below code is used to get the tbaguiLifeCycleList data */
      const tbaguiLifeCycleList = respDataObj?.[Constants.TBAGUI_LIFECYCLE];
      
      if (tbaguiLifeCycleList) {
        this.rootScope.tbaguiLifeCycleList = tbaguiLifeCycleList;
      } else {
        this.rootScope.tbaguiLifeCycleAPIFailure = true;
      }

      /** Below code is used to get the planTypesForHealthCard params data for Approved Exception */
      const planTypesData = respDataObj?.[Constants.PLAN_TYPES_FOR_HEALTH_CARD];
      if (planTypesData) {
        planTypesData.sort((a, b) => parseFloat(a?.sequence) - parseFloat(b?.sequence));
        const planTypesArray = planTypesData?.map(item => item?.fieldValue);
        this.rootScope.planTypesForHealthCard = planTypesArray;
      } 

      /** Below code is used to get the KC_PORTAL_LIST for Support Links in Customer Information- Domains(i.DB DC) */
      const kcPortalList  = respDataObj?.[Constants.KC_PORTAL_LIST];
      if (kcPortalList) {
        kcPortalList.sort((a, b) => parseFloat(a?.sequence) - parseFloat(b?.sequence));
        this.rootScope.kcPortalList = kcPortalList;
      }

      /** Below code is used to get the healthCardApprovedExceptionList data */
      const healthCardApprovedExceptionData = respDataObj?.[Constants.HEALTH_CARD_APPROVED_EXCEPTIONS]?.map(item => item?.fieldValueDescription.split('|')).flat();

      if (healthCardApprovedExceptionData) {
        this.rootScope.healthCardApprovedExceptionList = healthCardApprovedExceptionData;
      }

      /** Below code is used to get wrapup data from db CCR1-10791 */

      const interactionTypeData = respDataObj?.[Constants.INTERACTION_TYPE];
      /* istanbul ignore next */
      if (interactionTypeData) {
        this.rootScope.interactionTypeList = interactionTypeData;
      }
      
      const interactionModesData = respDataObj?.[Constants.INTERACTION_MODES];
      /* istanbul ignore next */
      if (interactionModesData) {
        this.rootScope.interactionModesList = interactionModesData;
      }
      
      const interactionModeSubTypeData = respDataObj?.[Constants.INTERACTION_MODE_SUBTYPE];
      /* istanbul ignore next */
      if (interactionModeSubTypeData) {
        this.rootScope.interactionModeSubTypeList = interactionModeSubTypeData;
      }

      //CCR1-12455 Wrapup code changes - fetching disposition method and location from valid value API
      const interactionDispositionMethodData = respDataObj?.[Constants.INTERACTION_ENDED_METHOD];
      if (interactionDispositionMethodData) {
        this.rootScope.interactionDispositionMethodList = interactionDispositionMethodData;
      }


      const interactionDispositionLocationData = respDataObj?.[Constants.INTERACTION_ENDED_LOCATION];
      if (interactionDispositionLocationData) {
        this.rootScope.interactionDispositionLocationList = interactionDispositionLocationData;
      }



      if(respDataObj?.[Constants.MYFRSLINK]){
        this.rootScope.myFRSLink = respDataObj?.[Constants.MYFRSLINK][0]?.fieldValueDescription;
      }

      if(respDataObj?.[Constants.UNKNOWN_CLIENT_QUEUES]?.length){
        this.rootScope.unknownClientQueues = respDataObj?.[Constants.UNKNOWN_CLIENT_QUEUES].map(queue => queue.fieldValue.trim());
      }

      /* CCR1-13584- Fetching TBA error codes and descriptions from valid values API */
      const tbaErrorsData = respDataObj?.[Constants.TBA_ERRORS];
      if (tbaErrorsData) {
        this.rootScope.tbaErrorCodesMap = new Map(tbaErrorsData?.map(item => [item?.fieldValue, item?.fieldValueDescription]));
      }

        
    },
    error: (err) => {
      this.rootScope.getValidFieldValuesApiFailure = true;
    }
  })
}



/**
 * Below method is used to retry the valid value api when it fails.
 */
retryValidValueAPi(){ 
  this.getDataForCustomerAccountApi();

  if(this.rootScope.utilityStatusClass== this.utilityError){
    this.dashboardService.reLunchUtility();
  }
}

 ngOnDestroy() {
    this.subscription.unsubscribe();
    this.networkSpeedSubscription.unsubscribe();
    clearTimeout(this.rootScope.alisRegistrationLoaderTimeoutId);
    this.rootScope.showAlisRegistrationLoaderMsg = false;
    this.rootScope.alisRegistrationLoader = false;
    this.rootScope.browserSubscription?.unsubscribe();
    this.rootScope.patchGENAttribute.unsubscribe();
    this.dialog.closeAll();
    if (this.rootScope.GenesysPureCloud) clearInterval(this.rootScope.GenesysPureCloud);
  }

}

